import "../base-nYmjnkiN.js";
import "react";
import t from "../core/hooks/useGtm.js";
import "react/jsx-runtime";
import "../index-C7ezJk5b.js";
import "react-dom";
import '../assets/Wrapper.css';/* empty css                  */
import "react-router-dom";
const l = () => (t(), null);
export {
  l as GtmInit
};
